"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ACTION_HANDLER_STATUS: () => ACTION_HANDLER_STATUS,
  ActionGroup: () => ActionGroup,
  ActionKind: () => ActionKind,
  ActivityType: () => ActivityType,
  BlockFormat: () => BlockFormat,
  DAYS: () => DAYS,
  Division: () => Division,
  HttpMethod: () => HttpMethod,
  MemberStatus: () => MemberStatus,
  Months: () => Months,
  POSITION: () => POSITION,
  Placeholder: () => Placeholder,
  ProjectMemberAdditionalRole: () => ProjectMemberAdditionalRole,
  ProjectStatus: () => ProjectStatus,
  ResumeStep: () => ResumeStep,
  RichTextStylePreset: () => RichTextStylePreset,
  TextFormat: () => TextFormat,
  TimelineLoadingState: () => TimelineLoadingState,
  ToastStatus: () => ToastStatus,
  UserGroup: () => UserGroup,
  WorkPlace: () => WorkPlace
});
module.exports = __toCommonJS(src_exports);

// src/common.ts
var POSITION = /* @__PURE__ */ ((POSITION2) => {
  POSITION2["LEFT"] = "left";
  POSITION2["RIGHT"] = "right";
  return POSITION2;
})(POSITION || {});

// src/textEditor.ts
var RichTextStylePreset = /* @__PURE__ */ ((RichTextStylePreset2) => {
  RichTextStylePreset2["DEFAULT"] = "default";
  RichTextStylePreset2["CHATBOT"] = "chatbot";
  return RichTextStylePreset2;
})(RichTextStylePreset || {});
var TextFormat = /* @__PURE__ */ ((TextFormat2) => {
  TextFormat2["BOLD"] = "bold";
  TextFormat2["ITALIC"] = "italic";
  TextFormat2["UNDERLINE"] = "underline";
  TextFormat2["CODE"] = "code";
  return TextFormat2;
})(TextFormat || {});
var BlockFormat = /* @__PURE__ */ ((BlockFormat2) => {
  BlockFormat2["PARAGRAPH"] = "paragraph";
  BlockFormat2["HEADING_1"] = "heading-1";
  BlockFormat2["HEADING_2"] = "heading-2";
  BlockFormat2["BLOCK_QUOTE"] = "block-quote";
  BlockFormat2["CODE_BLOCK"] = "code-block";
  BlockFormat2["BULLETED_LIST"] = "bulleted-list";
  BlockFormat2["NUMBERED_LIST"] = "numbered-list";
  BlockFormat2["LIST_ITEM"] = "list-item";
  BlockFormat2["LINK"] = "link";
  return BlockFormat2;
})(BlockFormat || {});

// src/resume.ts
var ResumeStep = /* @__PURE__ */ ((ResumeStep2) => {
  ResumeStep2["TEMPLATE_SELECTION"] = "TEMPLATE_SELECTION";
  ResumeStep2["PERSONAL_INFO"] = "PERSONAL_INFO";
  ResumeStep2["WORK_EXPERIENCE"] = "WORK_EXPERIENCE";
  ResumeStep2["SKILLS"] = "SKILLS";
  ResumeStep2["EDUCATION"] = "EDUCATION";
  ResumeStep2["SOCIAL_LINKS"] = "SOCIAL_LINKS";
  ResumeStep2["CERTIFICATIONS"] = "CERTIFICATIONS";
  return ResumeStep2;
})(ResumeStep || {});

// src/image.ts
var Placeholder = /* @__PURE__ */ ((Placeholder2) => {
  Placeholder2["Blur"] = "blur";
  Placeholder2["Empty"] = "empty";
  return Placeholder2;
})(Placeholder || {});

// src/api.ts
var HttpMethod = /* @__PURE__ */ ((HttpMethod2) => {
  HttpMethod2["GET"] = "GET";
  HttpMethod2["POST"] = "POST";
  HttpMethod2["PUT"] = "PUT";
  HttpMethod2["PATCH"] = "PATCH";
  HttpMethod2["DELETE"] = "DELETE";
  return HttpMethod2;
})(HttpMethod || {});

// src/action.ts
var ActionKind = /* @__PURE__ */ ((ActionKind2) => {
  ActionKind2["SUGGESTION"] = "suggestion";
  ActionKind2["REDIRECT"] = "redirect";
  ActionKind2["HANDLER"] = "handler";
  ActionKind2["ACTION"] = "action";
  ActionKind2["VALIDATION"] = "validation";
  return ActionKind2;
})(ActionKind || {});
var ActivityType = /* @__PURE__ */ ((ActivityType2) => {
  ActivityType2["ACTIVITY_UPDATE"] = "activity_update";
  ActivityType2["USER_ACTIVATE"] = "user_activate";
  ActivityType2["USER_DEACTIVATE"] = "user_deactivate";
  ActivityType2["USER_UPDATE_ROLE"] = "user_update_role";
  ActivityType2["EMPLOYEE_UPDATE_INFO"] = "employee_update_info";
  ActivityType2["EMPLOYEE_UPDATE_SKILLS"] = "employee_update_skills";
  ActivityType2["EMPLOYEE_UPDATE_PROFILE"] = "employee_update_profile";
  ActivityType2["EMPLOYEE_UPDATE_MY_PROFILE"] = "employee_update_my_profile";
  ActivityType2["EMPLOYEE_VIEW_PROFILE"] = "employee_view_profile";
  ActivityType2["EMPLOYEE_VIEW_MY_PROFILE"] = "employee_view_my_profile";
  ActivityType2["EMPLOYEE_ASSIGN_MENTOR"] = "employee_assign_mentor";
  ActivityType2["EMPLOYEE_ASSIGN_MENTEE"] = "employee_assign_mentee";
  ActivityType2["EMPLOYEE_UNASSIGN_MENTEE"] = "employee_unassign_mentee";
  ActivityType2["EMPLOYEE_UNASSIGN_MENTOR"] = "employee_unassign_mentor";
  ActivityType2["PROJECT_VIEW"] = "project_view";
  ActivityType2["PROJECT_CREATE"] = "project_create";
  ActivityType2["PROJECT_UPDATE"] = "project_update";
  ActivityType2["PROJECT_KICK_OFF"] = "project_kick_off";
  ActivityType2["PROJECT_RELEASE"] = "project_release";
  ActivityType2["PROJECT_PAUSE"] = "project_pause";
  ActivityType2["PROJECT_RESUME"] = "project_resume";
  ActivityType2["PROJECT_GO_LIVE"] = "project_go_live";
  ActivityType2["PROJECT_COMPLETE"] = "project_complete";
  ActivityType2["PROJECT_MEMBER_JOIN"] = "project_member_join";
  ActivityType2["PROJECT_MEMBER_ROLE_CHANGE"] = "project_member_role_change";
  ActivityType2["PROJECT_MEMBER_LEAVE"] = "project_member_leave";
  ActivityType2["PROJECT_MEMBER_RESUME"] = "project_member_resume";
  ActivityType2["PROJECT_MEMBER_REMOVE"] = "project_member_remove";
  ActivityType2["PROJECT_ARCHIVE"] = "project_archive";
  ActivityType2["PROJECT_UNARCHIVE"] = "project_unarchive";
  ActivityType2["PROJECT_SCHEDULE_ACTIVITY"] = "project_schedule_activity";
  ActivityType2["TRAINING_CREATE"] = "training_create";
  ActivityType2["TRAINING_UPDATE"] = "training_update";
  ActivityType2["TRAINING_VIEW"] = "training_view";
  ActivityType2["TRAINING_START"] = "training_start";
  ActivityType2["TRAINING_COMPLETE"] = "training_complete";
  ActivityType2["TRAINING_PAUSE"] = "training_pause";
  ActivityType2["TRAINING_RESUME"] = "training_resume";
  ActivityType2["TRAINING_FEEDBACK_RECEIVED"] = "training_feedback";
  ActivityType2["TRAINING_FEEDBACK_PRESENTATION"] = "training_feedback_presentation";
  ActivityType2["TRAINING_ASSIGN_SUPPORTER"] = "training_assign_supporter";
  ActivityType2["TRAINING_UNASSIGN_SUPPORTER"] = "training_unassign_supporter";
  ActivityType2["TRAINING_ASSIGN_TRAINEE"] = "training_assign_trainee";
  ActivityType2["TRAINING_PRESENTATION"] = "training_presentation";
  ActivityType2["TRAINING_UPDATE_PRESENTATION"] = "training_update_presentation";
  ActivityType2["TRAINING_REQUEST_FEEDBACK_PRESENTATION"] = "training_request_feedback_presentation";
  ActivityType2["TRAINING_UPDATE_FEEDBACK"] = "training_update_feedback";
  ActivityType2["TRAINING_UPDATE_FEEDBACK_PRESENTATION"] = "training_update_feedback_presentation";
  ActivityType2["TRAINING_UNASSIGN_PARTICIPANT"] = "training_unassign_participant";
  ActivityType2["TRAINING_ARCHIVE"] = "training_archive";
  ActivityType2["TRAINING_UNARCHIVE"] = "training_unarchive";
  ActivityType2["TRAINING_ARCHIVE_PRESENTATION"] = "training_archive_presentation";
  ActivityType2["TRAINING_UNARCHIVE_PRESENTATION"] = "training_unarchive_presentation";
  ActivityType2["TICKET_APPROVE"] = "ticket_approve";
  ActivityType2["TICKET_REJECT"] = "ticket_reject";
  ActivityType2["TICKET_PENDING"] = "ticket_pending";
  ActivityType2["TICKET_DONE"] = "ticket_done";
  ActivityType2["TICKET_CLOSE"] = "ticket_close";
  ActivityType2["TICKET_REALLOCATION"] = "ticket_reallocation";
  ActivityType2["TICKET_ROOM_BOOKING"] = "ticket_room_booking";
  ActivityType2["TICKET_TIME_OFF"] = "ticket_time_off";
  ActivityType2["TICKET_MAINTENANCE"] = "ticket_maintenance";
  ActivityType2["TICKET_LUNCH_REGISTRATION"] = "ticket_lunch_registration";
  ActivityType2["TICKET_ON_BEHALF_LUNCH_REGISTRATION"] = "ticket_on_behalf_lunch_registration";
  ActivityType2["TICKET_ON_BEHALF_TIME_OFF"] = "ticket_on_behalf_time_off";
  ActivityType2["RESUME_VIEW_MY"] = "resume_view_my";
  ActivityType2["RESUME_DOWNLOAD_MY"] = "resume_download_my";
  ActivityType2["RESUME_DOWNLOAD_MY_DOCX"] = "resume_download_my_docx";
  ActivityType2["RESUME_UPDATE_MY"] = "resume_update_my";
  ActivityType2["RESUME_VIEW"] = "resume_view";
  ActivityType2["RESUME_CREATE"] = "resume_create";
  ActivityType2["RESUME_DOWNLOAD"] = "resume_download";
  ActivityType2["VIEW_MENU"] = "view_menu";
  ActivityType2["VIEW_STATISTIC"] = "view_statistic";
  ActivityType2["COMPARE_STATISTIC"] = "compare_statistic";
  ActivityType2["RESUME_DOWNLOAD_DOCX"] = "resume_download_docx";
  return ActivityType2;
})(ActivityType || {});
var ActionGroup = /* @__PURE__ */ ((ActionGroup2) => {
  ActionGroup2["RESUME"] = "resume";
  ActionGroup2["USER"] = "user";
  ActionGroup2["PROJECT"] = "project";
  ActionGroup2["EMPLOYEE"] = "employee";
  ActionGroup2["TRAINING"] = "training";
  ActionGroup2["MENU"] = "menu";
  ActionGroup2["STATISTIC"] = "statistic";
  return ActionGroup2;
})(ActionGroup || {});

// src/project.ts
var MemberStatus = /* @__PURE__ */ ((MemberStatus2) => {
  MemberStatus2["JOINED"] = "joined";
  MemberStatus2["RESUMED"] = "resumed";
  MemberStatus2["LEFT"] = "left";
  MemberStatus2["PAUSED"] = "paused";
  MemberStatus2["COMPLETED"] = "completed";
  return MemberStatus2;
})(MemberStatus || {});
var TimelineLoadingState = /* @__PURE__ */ ((TimelineLoadingState2) => {
  TimelineLoadingState2[TimelineLoadingState2["IDLE"] = 0] = "IDLE";
  TimelineLoadingState2[TimelineLoadingState2["INITIAL_LOADING"] = 1] = "INITIAL_LOADING";
  TimelineLoadingState2[TimelineLoadingState2["LOADING_MORE"] = 2] = "LOADING_MORE";
  return TimelineLoadingState2;
})(TimelineLoadingState || {});
var ProjectMemberAdditionalRole = /* @__PURE__ */ ((ProjectMemberAdditionalRole2) => {
  ProjectMemberAdditionalRole2["SUPPORTER"] = "supporter";
  ProjectMemberAdditionalRole2["HOT_TRAINING"] = "hot_training";
  ProjectMemberAdditionalRole2["SHADOW"] = "shadow";
  return ProjectMemberAdditionalRole2;
})(ProjectMemberAdditionalRole || {});
var ProjectStatus = /* @__PURE__ */ ((ProjectStatus2) => {
  ProjectStatus2["WAITING_FOR_KICK_OFF"] = "waiting_for_kick_off";
  ProjectStatus2["ACTIVE"] = "active";
  ProjectStatus2["PAUSED"] = "paused";
  ProjectStatus2["RESUMED"] = "resumed";
  ProjectStatus2["COMPLETED"] = "completed";
  return ProjectStatus2;
})(ProjectStatus || {});

// src/employee.ts
var WorkPlace = /* @__PURE__ */ ((WorkPlace2) => {
  WorkPlace2["LH"] = "LH";
  WorkPlace2["NT"] = "604";
  WorkPlace2["HPT"] = "HPT";
  WorkPlace2["TL18"] = "TL18";
  WorkPlace2["HOME"] = "Home";
  return WorkPlace2;
})(WorkPlace || {});
var UserGroup = /* @__PURE__ */ ((UserGroup2) => {
  UserGroup2["CHEF"] = "chef";
  UserGroup2["KITCHEN_MANAGER"] = "kitchen_manager";
  UserGroup2["ON_BEHALF_MANAGER"] = "on_behalf_manager";
  UserGroup2["BGH"] = "bgh";
  UserGroup2["HF"] = "hf";
  return UserGroup2;
})(UserGroup || {});
var Division = /* @__PURE__ */ ((Division2) => {
  Division2["BGH"] = "big game hunters";
  Division2["HF"] = "hellfire";
  Division2["FP"] = "fastest possible";
  Division2["LT"] = "lost temple";
  Division2["BT"] = "blue storm";
  Division2["AT"] = "athena";
  Division2["LN"] = "lunar";
  return Division2;
})(Division || {});

// src/calendar.ts
var Months = /* @__PURE__ */ ((Months2) => {
  Months2["JAN"] = "Jan";
  Months2["FEB"] = "Feb";
  Months2["MAR"] = "Mar";
  Months2["APR"] = "Apr";
  Months2["MAY"] = "May";
  Months2["JUN"] = "Jun";
  Months2["JUL"] = "Jul";
  Months2["AUG"] = "Aug";
  Months2["SEP"] = "Sep";
  Months2["OCT"] = "Oct";
  Months2["NOV"] = "Nov";
  Months2["DEC"] = "Dec";
  return Months2;
})(Months || {});
var DAYS = /* @__PURE__ */ ((DAYS2) => {
  DAYS2["SU"] = "Su";
  DAYS2["SA"] = "Sa";
  return DAYS2;
})(DAYS || {});

// src/toast.ts
var ToastStatus = /* @__PURE__ */ ((ToastStatus2) => {
  ToastStatus2["Success"] = "success";
  ToastStatus2["Error"] = "error";
  ToastStatus2["Info"] = "info";
  return ToastStatus2;
})(ToastStatus || {});

// src/chat.ts
var ACTION_HANDLER_STATUS = /* @__PURE__ */ ((ACTION_HANDLER_STATUS2) => {
  ACTION_HANDLER_STATUS2["COMPLETE"] = "complete";
  ACTION_HANDLER_STATUS2["INPROGRESS"] = "inProgress";
  ACTION_HANDLER_STATUS2["EXECUTING"] = "executing";
  return ACTION_HANDLER_STATUS2;
})(ACTION_HANDLER_STATUS || {});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ACTION_HANDLER_STATUS,
  ActionGroup,
  ActionKind,
  ActivityType,
  BlockFormat,
  DAYS,
  Division,
  HttpMethod,
  MemberStatus,
  Months,
  POSITION,
  Placeholder,
  ProjectMemberAdditionalRole,
  ProjectStatus,
  ResumeStep,
  RichTextStylePreset,
  TextFormat,
  TimelineLoadingState,
  ToastStatus,
  UserGroup,
  WorkPlace
});
